import ingealimentosApi, { getDomain } from '../../services/ingealimentosApi'

export const getServiceEquipments = params => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get('/service_equipments', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getServiceEquipment = (id, params) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.get(`/service_equipments/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeServiceEquipment = data => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.post('/service_equipments', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateServiceEquipment = (id, data) => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.put(`/service_equipments/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteServiceEquipment = id => (
	new Promise((resolve, reject) => {
		ingealimentosApi()
			.delete(`/service_equipments/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const searchServiceEquipments = async (term, token) => (
	fetch( getDomain()+`/service_equipments?filter[name]=${term}`, {
		headers: {'Authorization': `Bearer ${token}`}
	})
		.then((response) => response.json())
		.then((res) =>
			res.data.map(item => ({
				label: item.name,
				value: item.id,
			})),
		)
)